<template>
  <div>
    <nav class="navbar navbar-expand-md navbar-light bg-light Upper">
      <a
        class="navbar-brand col"
        style="font-weight: bold; letter-spacing: 1px"
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/d/d3/Soccerball.svg"
          style="padding-bottom: 2px; width: 20px"
          class="d-inline-block"
        />
        {{ $t("LanguageEn.txtNavbar") }}
      </a>
      <div class="collapse navbar-collapse" id="navbarNav1">
        <ul class="navbar-nav" style="">
          <li class="nav-item">
            <router-link
              id="routerLink1"
              :to="{ name: 'Finished', params: { dateS: getGameDay(-3) } }"
              >{{ date1 | transliterate(cookiesObject.lang) }}</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              id="routerLink1"
              :to="{ name: 'Finished', params: { dateS: getGameDay(-2) } }"
              >{{ date2 | transliterate(cookiesObject.lang) }}</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              id="routerLink1"
              :to="{ name: 'Finished', params: { dateS: getGameDay(-1) } }"
              >{{ date3 | transliterate(cookiesObject.lang) }}</router-link
            >
          </li>
          <li class="nav-item">
            <router-link class="active" id="routerLink1" to="/Today">{{
              $t("LanguageEn.tabToday")
            }}</router-link>
          </li>
          <li class="nav-item">
            <router-link
              id="routerLink1"
              :to="{ name: 'Finished', params: { dateS: getGameDay(1) } }"
              >{{ date4 | transliterate(cookiesObject.lang) }}</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              id="routerLink1"
              :to="{ name: 'Finished', params: { dateS: getGameDay(2) } }"
              >{{ date5 | transliterate(cookiesObject.lang) }}</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              id="routerLink1"
              :to="{ name: 'Finished', params: { dateS: getGameDay(3) } }"
              >{{ date6 | transliterate(cookiesObject.lang) }}</router-link
            >
          </li>
        </ul>
      </div>
      <div
        style="
          margin-left: auto;
          color: white !important;
          height: 40px;
          width: 60px;
        "
        v-on:click="(dateIden = value), setLIDs()"
      >
        <b-form-datepicker
          @input="redirect()"
          button-only
          selected-variant="success"
          button-variant="success"
          today-variant="success"
          placeholder="Today"
          id="example-datepicker"
          right
          size="md"
          v-model="value"
          class="mb-2"
          style="
            border: none;
            background: none;
            margin-left: 7px;
            border-radius: 0px;
          "
        ></b-form-datepicker>
      </div>
      <span style="float: right">
        <b-modal
          :modal-class="myclass"
          ref="mysearch-modal1"
          id="modal-search"
          title-class="bb"
          title="Search"
          hide-footer
        >
          <div
            class="row"
            style="margin-bottom: 15px; margin-left: 5px; margin-right: 5px"
          >
            <b-form-input
              class="col"
              v-model="message"
              placeholder="Type your search here"
              @keyup.enter="searchT(message)"
              style="
                border: solid #357439;
                border-width: 2px;
                color: white;
                background: #212225;
              "
            ></b-form-input>
            <b-button
              variant="none"
              @click="searchT(message)"
              style="margin-left: 2px"
              class="col-1"
            >
              <img
                src="@/assets/search.png"
                style="width: 15px; margin-top: -3px"
                alt=""
              />
            </b-button>
          </div>
          <b-tabs
            v-if="appear"
            content-class="mt-2"
            style="background: #1a1a1d"
            nav-class="cs1"
            active-nav-item-class="cs"
          >
            <b-tab active style="" class="mytab" title-link-class="tab1">
              <template v-slot:title>
                <p style="margin: 0px; color: lightgrey; font-size: 13px">
                  Teams
                </p>
              </template>
              <ul
                v-for="searchr in search.results"
                :key="searchr.id"
                style="
                  list-style-type: none;
                  padding-left: 0px;
                  margin-left: 10px;
                  font-size: 13px;
                "
              >
                <li
                  v-if="searchr.type == 'team'"
                  style="border-bottom: 1px solid rgba(169, 169, 169, 0.1)"
                >
                  <div
                    class="row"
                    v-if="cookiesObject.token"
                    style="margin-left: 5px"
                  >
                    <div class="" @click="hideModal1()">
                      <router-link
                        class=""
                        style="color: lightgrey; font-weight: 400px"
                        id=""
                        :to="{
                          name: 'teamPagePar',
                          params: { id: searchr.id },
                        }"
                      >
                        <img
                          :src="teamLogo + searchr.id"
                          alt=""
                          style="
                            width: 18px;
                            margin-top: -5px;
                            margin-right: 3px;
                          "
                        />
                        <span style="font-weight: 400">
                          {{ searchr.name }}
                        </span>
                      </router-link>
                    </div>
                    <img
                      v-if="favs.some((fav) => fav.id === searchr.id)"
                      v-on:click="
                        removeFavorite({ value: searchr.id, type: team })
                      "
                      :src="favImage1"
                      style="
                        width: 15px;
                        cursor: pointer;
                        margin-left: 10px;
                        margin-bottom: 5px;
                      "
                      alt=""
                    />
                    <img
                      v-else
                      v-on:click="
                        addToFavorites({ value: searchr.id, type: team })
                      "
                      :src="favImage"
                      style="
                        width: 15px;
                        cursor: pointer;
                        margin-left: 10px;
                        margin-bottom: 5px;
                      "
                      alt=""
                    />
                  </div>
                  <span
                    class="kek"
                    v-else
                    data-toggle="modal"
                    @click="hideModal1()"
                    data-target="#exampleModal"
                    style="cursor: pointer"
                  >
                    {{ searchr.name }}
                  </span>
                </li>
              </ul>
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <p style="margin: 0px; color: lightgrey; font-size: 13px">
                  Tournaments
                </p>
              </template>
              <ul
                v-for="searchr in search.results"
                :key="searchr.id"
                style="
                  list-style-type: none;
                  padding-left: 0px;
                  margin-left: 10px;
                  font-size: 13px;
                "
              >
                <li
                  v-if="searchr.type == 'tournament'"
                  style="border-bottom: 1px solid rgba(169, 169, 169, 0.1)"
                >
                  <div
                    class="row"
                    v-if="cookiesObject.token"
                    style="margin-left: 5px"
                  >
                    <div class="" @click="hideModal1()">
                      <router-link
                        class=""
                        style="color: lightgrey; font-weight: 400px"
                        id=""
                        :to="{
                          name: 'LeaguePageNav',
                          params: { leagueId: searchr.id },
                        }"
                      >
                        <img
                          :src="teamLogo + searchr.id"
                          alt=""
                          style="
                            width: 18px;
                            margin-top: -5px;
                            margin-right: 3px;
                          "
                        />
                        <span style="font-weight: 400">
                          {{ searchr.name }}
                        </span>
                      </router-link>
                    </div>
                    <img
                      v-if="favsT.some((fav) => fav.id === searchr.id)"
                      v-on:click="
                        removeFavorite({ value: searchr.id, type: tournament })
                      "
                      :src="favImage1"
                      style="
                        width: 15px;
                        cursor: pointer;
                        margin-left: 10px;
                        margin-bottom: 5px;
                      "
                      alt=""
                    />
                    <img
                      v-else
                      v-on:click="
                        addToFavorites({ value: searchr.id, type: tournament })
                      "
                      :src="favImage"
                      style="
                        width: 15px;
                        cursor: pointer;
                        margin-left: 10px;
                        margin-bottom: 5px;
                      "
                      alt=""
                    />
                  </div>
                  <span
                    class="kek"
                    v-else
                    data-toggle="modal"
                    data-target="#exampleModal"
                    style="cursor: pointer"
                  >
                    {{ searchr.name }} KEK</span
                  >
                </li>
              </ul>
            </b-tab>
          </b-tabs>
        </b-modal>
      </span>
    </nav>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";

export default {
  name: "Navbar",
  data() {
    return {
      dateIden: "",
      cookiesObject: "",
      search: [],
      message: "",
      appear: false,
      date1: "",
      date2: "",
      date3: "",
      date4: "",
      date5: "",
      date6: "",
      value: "",
      ssize: "",
      myclass: ["myclass"],
      teamLogo: "https://sportapi.zuniac.com/team/logo/",
      tournamentLogo: "https://sportapi.zuniac.com/tournament/logo/",
      favImage: require("@/assets/favorite.png"),
      favImage1: require("@/assets/orStar.png"),
      team: "team",
      tournament: "tournament",
    };
  },
  mounted() {
    var cookiesObject = document.cookie
      .split(";")
      .map((cookie) => cookie.split("="))
      .reduce(
        (accumulator, [key, value]) => ({
          ...accumulator,
          [key.trim()]: decodeURIComponent(value),
        }),
        {}
      );
    this.cookiesObject = cookiesObject;
  },
  computed: {
    ...mapGetters(["dateNtime", "httpReq", "favs", "favsT"]),
    monthNames() {
      return [
        this.$t("LanguageEn.month1"),
        this.$t("LanguageEn.month2"),
        this.$t("LanguageEn.month3"),
        this.$t("LanguageEn.month4"),
        this.$t("LanguageEn.month5"),
        this.$t("LanguageEn.month6"),
        this.$t("LanguageEn.month7"),
        this.$t("LanguageEn.month8"),
        this.$t("LanguageEn.month9"),
        this.$t("LanguageEn.month10"),
        this.$t("LanguageEn.month11"),
        this.$t("LanguageEn.month12"),
      ];
    },
  },
  methods: {
    ...mapActions(["setdateNtime", "removeFavorite", "addToFavorites"]),
    hideModal1() {
      this.$refs["mysearch-modal1"].hide();
    },
    setLIDs() {
      this.setdateNtime(this.dateIden);
    },

    async searchT(value) {
      const res = await fetch(
        this.httpReq +
          "/search?portalId=" +
          (this.cookiesObject.portalId ? this.cookiesObject.portalId : 0) +
          "&query=" +
          value
      );
      const data = await res.json();
      const search = data;
      this.search = search;
      this.appear = true;
    },
    nowSize() {
      this.ssize = window.innerWidth;
    },
    redirect() {
      if (this.value != undefined) {
        this.$router.push({ name: "Finished", params: { dateS: this.value } });
      }
    },

    getGameDay(day) {
      var dt = new Date();
      dt.setDate(dt.getDate() + day);
      var fdDate = dt.getDate();
      var fdMonth = dt.getMonth() + 1;
      var fdYear = dt.getFullYear();

      if (day == 1) {
        this.date4 = dt.getDate() + " " + this.monthNames[fdMonth - 1];
      } else if (day == 2) {
        this.date5 = dt.getDate() + " " + this.monthNames[fdMonth - 1];
      } else if (day == 3) {
        this.date6 = dt.getDate() + " " + this.monthNames[fdMonth - 1];
      } else if (day == -1) {
        this.date3 = dt.getDate() + " " + this.monthNames[fdMonth - 1];
      } else if (day == -2) {
        this.date2 = dt.getDate() + " " + this.monthNames[fdMonth - 1];
      } else if (day == -3) {
        this.date1 = dt.getDate() + " " + this.monthNames[fdMonth - 1];
      } else {
        console.log("date navbar error");
      }

      if (fdMonth.toString().length == 1) {
        fdMonth = "0" + fdMonth;
      }
      if (fdDate.toString().length == 1) {
        fdDate = "0" + fdDate;
      }

      var fd = fdYear + "-" + fdMonth + "-" + fdDate;
      return fd;
    },
  },
  components: {},
  props: {},
};
</script>

<style scoped>
.nav-item {
  font-size: small;
}

#routerLink1 {
  text-decoration: none;
  padding: 12px 15px 12px 15px;
  line-height: 40px;
  color: rgb(236, 233, 233);
}
#routerLink1:hover {
  background: #326e37;
}
#routerLink1 .navbar-nav li > a {
  text-transform: capitalize;
  transition: background-color 0.2s, color 0.2s;
}

#routerLink1 .navbar-nav li > a:focus {
  color: #fff;
  font-weight: 550;
}

.router-link-active {
  background: #326e37;
}

@media only screen and (max-width: 600px) {
  body {
    background: #212529;
  }
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 600px) {
  .MobileShow {
    display: none;
  }
}

@media only screen and (min-width: 600px) and (max-width: 1200px) {
  #routerLink1 {
    padding-top: 10%;
    padding-left: 0px !important;
    display: inline-block;
    text-decoration: none;
    width: 64px;
    height: 40px !important;
    color: white;
    text-align: center !important;
    font-weight: 550;
  }
}
.Upper {
  background: #1b5e20 !important;
}

.navbar-brand {
  color: white !important;
  font-size: 16px !important;
}
</style>
<style>
.myclass > .modal-dialog > .modal-content > .modal-header {
  background-color: #212225;
  font-weight: 500 !important;
  border: none;
  border-radius: 0px;
  font-size: 10px !important;
}
.myclass > .modal-dialog > .modal-content > .modal-body {
  background-color: #1a1a1d;
  color: #e6e6e6;
  font-weight: 600;
  border: none;
  border-radius: 0px;
}
.myclass > .modal-dialog > .modal-content > .modal-header > .close {
  color: white;
}
.bb {
  color: #e6e6e6;
  font-size: 12px;
}

.tab1 {
  background-color: none !important;
}
.cs {
  background: none !important;
  border-radius: 0px !important;
  border-bottom: solid #357439 !important;
  border-left: none !important;
  border-right: none !important;
  border-top: none !important;
}
.cs1 {
  background: none !important;
  border-radius: 0px !important;
  border: none;
}
</style>
